import { render } from "./EditCompanyInfo.vue?vue&type=template&id=56aa75b6"
import script from "./EditCompanyInfo.vue?vue&type=script&lang=js"
export * from "./EditCompanyInfo.vue?vue&type=script&lang=js"

import "./EditCompanyInfo.vue?vue&type=style&index=0&id=56aa75b6&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__